module.exports = __webpack_public_path__ + "static/media/profile-complete-img.1229b2ab.svg";